import React from "react";

import { instantSave } from "../../helpers.js";
import Cx from "classnames";
import styles from "./styles.scss";

const getAssociationPanelArtistIds = () => $("#project_artist_assocs").val();
const disableArtistAssociationPanel = () => {
  $("#project_artist_assocs").closest(".artist-associations").addClass("disabled");
  $("#project_artist_assocs").remove();
};

export default class Supertag extends React.Component {
  state = {
    artistList: "",
    hidden: "",
    open: false,
  };

  handleInputChange = (e) => {
    // only allow paste
  };

  // parse each artist name by commas, try to find an existing artist record for each of them
  handlePaste = (e) => {
    const value = e.clipboardData.getData("Text");

    let artist_assocs = value.split(",").map((artist) => {
      // remove common typos that happen when pasting
      artist = artist
        .replace(/^\s+/, "")
        .replace(/\s+$/, "")
        .replace(/^and\s+/i, "")
        .replace(/^&\s+/i, "")
        .replace(/\.$/, "");

      let test = this.state.artists.filter(
        (space) =>
          this.normalizeArtist(artist) ==
          this.normalizeArtist(space.attributes.title)
      );

      if (test && test[0])
        return [
          test[0].id,
          { title: test[0].attributes.title, isNewArtist: false },
        ];

      return [`artist_name:${artist}`, { title: artist, isNewArtist: true }];
    });

    let artists = artist_assocs.map((row) => row[1]);
    artist_assocs = artist_assocs
      .map((row) => row[0])
      .concat(getAssociationPanelArtistIds())
      .join(",");

    // Prevent user from adding any more artists via the association panel
    // This avoids conflicting data from being input into Supertag and artist
    // association panel
    disableArtistAssociationPanel();
    
    if (!this.props.isNewProject) {
      // trigger instant save for not-new projects
      document.querySelector("body").classList.add("progress");

      this.timeout = setTimeout(() => {
        instantSave();
      }, 10);
    }

    this.setState({
      hidden: artist_assocs,
      artistList: artists,
      open: false,
    });
  };

  toggleOpen = () => {
    if (!this.state.open) {
      setTimeout(() => {
        this._input.focus();
      }, 10);
    }
    this.setState({ open: !this.state.open });
  };

  // ignore case, spaces, and latin accents like é
  normalizeArtist = (artist_name) => {
    if (!artist_name) return "";

    return artist_name
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .replace(" ", "")
      .toLowerCase();
  };

  componentDidMount() {
    fetch(`/api/rain/artists`)
      .then((res) => res.json())
      .then(
        (result) => {
          this.setState({
            artists: result.data,
          });
        },
        // Note: it's important to handle errors here
        // instead of a catch() block so that we don't swallow
        // exceptions from actual bugs in components.
        (error) => {
          this.setState({
            error,
          });
        }
      );
  }

  render() {
    if (this.state.artists)
      return (
        <div className={Cx(styles.wrap)}>
          <div className={styles.button} onClick={this.toggleOpen}>
            🏷
          </div>

          {this.state.open && (
            <div className={styles.popup}>
              <input
                ref={(c) => {
                  this._input = c;
                }}
                className={styles.input}
                type="text"
                spellCheck="false"
                value={""}
                onChange={this.handleInputChange}
                onPaste={this.handlePaste}
                onBlur={this.handleBlur}
                placeholder="Paste a comma-separated list"
              />
              <div className={styles.cancelButton} onClick={this.toggleOpen}>
                CANCEL
              </div>
            </div>
          )}

          <input
            type="hidden"
            name={this.props.fieldName}
            value={this.state.hidden}
          />

          {this.state.artistList.length > 0 && (
            <div className={Cx(styles.artistList)}>
              {this.state.artistList.map((artist, i) => (
                <div
                  key={artist.title}
                  className={Cx({ [styles.isNewArtist]: artist.isNewArtist })}
                >
                  {artist.title}
                </div>
              ))}
            </div>
          )}
        </div>
      );

    return <div className={Cx(styles.wrap)} />;
  }
}
